import { Card } from '../../SharedComponents/Card'
import { DataTable } from './DataTable'
import {
  formatCurrency,
  formatNegative,
  formatPercent,
} from '../../../lib/utils/format'
import type { Column, DisplayRow, FileTotalsCardProps } from '../types'
import styles from '../index.module.css'

const formatDealValue = (r: DisplayRow): string =>
  r.file_status === 'Clawback'
    ? formatNegative(r.deal_value)
    : formatCurrency(r.deal_value)

const columns: Column<DisplayRow>[] = [
  { title: 'File Status', key: 'file_status', accessor: 'file_status' },
  {
    title: 'Units',
    key: 'units',
    render: (r) => r.units,
  },
  {
    title: 'True Debt ($)',
    key: 'true_debt',
    render: (r) => formatCurrency(r.true_debt),
  },
  {
    title: 'Deal Value',
    key: 'deal_value',
    render: formatDealValue,
  },
  {
    title: '%',
    key: 'percent',
    render: (r) => formatPercent(r.percent),
  },
]

export default function FileTotalsCard({ rows, loading }: FileTotalsCardProps) {
  return (
    <Card>
      <div className={styles.cardHeader}>MY FILES — Topline</div>
      <DataTable
        columns={columns}
        data={rows}
        rowKey="file_status"
        loading={loading}
      />
    </Card>
  )
}
